import { loginRequest } from '@configs/authConfig';
import { AuthSessionExpiredError } from '@shared/errors/auth-session-expired-error';
import { removeAuthResponseHash } from '@shared/helpers/auth-response-hash/removeAuthResponseHash';
import { getMsalInstance } from '@shared/helpers/msal-instance/msalInstance';

export async function passwordReset(loginHint: string): Promise<void> {
  const msal = await getMsalInstance();

  await msal
    .loginRedirect({
      authority: `${import.meta.env.VITE_AUTH_BASE_AUTHORITY}/B2C_1A_passwordreset`,
      scopes: [...loginRequest.scopes],
      extraQueryParameters: {
        ...loginRequest.extraQueryParameters,
        login_hint: loginHint,
      },
      redirectStartPage: removeAuthResponseHash(globalThis.location.href),
    })
    .catch(error => {
      throw new AuthSessionExpiredError(
        `Session expired - password reset failed: ${error.message}`
      );
    });
}
